import ListsView from './ListsView';

export default ListsView;
